export default (data) => {
    const transformColors = {
        light_green: "lightGreen",
        dark_green: "darkGreen",
        light_greige: "lightGreige",
    };

    return transformColors[data] || data;
};
